import { IOrganization } from "@/api";

export const ALL_ORGS_SENTINEL = {
    id: -1,
    name: "All organizations",
} as IOrganization;

export function createOrgChangeHandler(
    currentValue: number | null,
    onChange: (id: number | null) => void,
    onChangeName?: (name: string | null) => void
) {
    return (newValue: IOrganization | null) => {
        if (newValue === null || newValue === ALL_ORGS_SENTINEL) {
            onChange(null);
            onChangeName?.(null);
        } else if (newValue.id === currentValue) {
            onChange(null);
            onChangeName?.(null);
        } else {
            onChange(newValue.id);
            onChangeName?.(newValue.name);
        }
    };
}
